import { Briefcase, CheckCircle2 } from "lucide-react";
import Section, { SectionHeading } from "../ui/Section";
import { useApp } from "../../context/AppContext";
import { experiences } from "../../data/content";

export default function ExperienceSection() {
  const { t, locale } = useApp();

  return (
    <Section id="experience" className="surface rounded-none">
      <SectionHeading tag={t("exp.tag")} title={t("exp.title")} />
      <div className="relative">
        {/* Timeline line */}
        <div className="absolute bottom-0 left-4 top-2 w-px bg-gradient-to-b from-cyan-400/60 via-soft to-transparent sm:left-5" />
        <div className="flex flex-col gap-8">
          {experiences.map((exp) => (
            <div key={exp.id} className="relative pl-12 sm:pl-16">
              <span className="absolute left-0 top-1 grid h-9 w-9 place-items-center rounded-xl border border-cyan-400/40 bg-cyan-400/10 text-cyan-300 sm:h-10 sm:w-10">
                <Briefcase className="h-4 w-4 sm:h-5 sm:w-5" />
              </span>
              <div className="rounded-2xl border border-soft card-bg p-6 transition-transform hover:-translate-y-1">
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <h3 className="font-display text-lg font-bold sm:text-xl">{exp.role[locale]}</h3>
                  <span className="text-xs font-medium text-cyan-400">{exp.period[locale]}</span>
                </div>
                <p className="mt-1 text-sm font-medium text-soft">{exp.org[locale]}</p>
                <ul className="mt-4 space-y-2">
                  {exp.bullets.map((b, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm leading-relaxed text-soft">
                      <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-cyan-400" />
                      <span>{b[locale]}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
